import DatePicker from '@elentari/components-eve/final-form/DatePicker'
import Filter from '@elentari/components-eve/components/Filter'
import Select from '@elentari/components-eve/final-form/Select'
import TextField from '@elentari/components-eve/final-form/TextField'
import { useQueryParams } from '@elentari/core'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import EventIcon from '@material-ui/icons/Event'
import { useEffect } from 'react'
import * as yup from 'yup'
import yupValidation from '../../utils/yupValidation'
import { useCenarioMetadata } from './hooks/useCenarioMetadata'
import { situacaoFiltroOptions } from './types'

const schema = yup.object().shape({
  tipo: yup.string().nullable().optional(),
  descricao: yup.string().optional(),
  ativo: yup.string().nullable().optional()
})

export type CenariosQueryFilter = {
  [key: string]: any
}

export const CenariosFilter = () => {
  const { clear, push, initialValues } = useQueryParams<CenariosQueryFilter>()
  const [{ metadata }, actions] = useCenarioMetadata()

  useEffect(() => {
    actions.fetchIfNeeded()
  }, []) // eslint-disable-line

  const tipoOptions = metadata
    ? Object.entries(metadata.tipos).map(([tipo, m]) => ({
        value: tipo,
        label: m.label
      }))
    : []

  const handleSubmitFilter = (values: Record<string, any>) => {
    if (!values.ativo) {
      delete values.ativo
    }
    push({ ...values })
  }

  return (
    <Filter
      labels={{ clear: 'Limpar', find: 'Buscar' }}
      initialValues={initialValues}
      onClear={clear}
      onSubmit={values => handleSubmitFilter({ ...values, page: 1 })}
      validate={yupValidation(schema)}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <Select
            fullWidth
            name="tipo"
            label="Tipo de Cenário"
            items={tipoOptions}
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <TextField fullWidth name="descricao" label="Descrição" />
        </Grid>
        <Grid item xs={12} sm={2}>
          <Select
            fullWidth
            name="ativo"
            label="Situação"
            items={situacaoFiltroOptions}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <DatePicker
            fullWidth
            name="vigenteEm"
            label="Vigente em"
            keyboardIcon={
              <Tooltip title="Selecionar data">
                <EventIcon />
              </Tooltip>
            }
          />
        </Grid>
      </Grid>
    </Filter>
  )
}
